import { Component, OnInit } from '@angular/core';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router, ActivatedRoute } from '@angular/router';
import { BackendApiService } from '../../../app/services/backend-api.service';
// import { ValidationService } from '../../../validation.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogOverviewExampleDialogComponent } from '../../dialog-overview-example-dialog/dialog-overview-example-dialog.component';
import { from } from 'rxjs';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-add-site-group',
  templateUrl: './add-site-group.component.html',
  styleUrls: ['./add-site-group.component.scss'],
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,MatIconModule,MatButtonModule]
})
export class AddSiteGroupComponent implements OnInit {
  private siteAddUrl = BaseUrlConstantsService.ADD_SITE;
  public associateSite = BaseUrlConstantsService.ASSOCIATE_SITE_USER;
  private updateSiteUrl = BaseUrlConstantsService.UPDATE_SITE;
  public applicationDeleteUrl = BaseUrlConstantsService.DELETE_APPLICATIONS;
  private addApplicationUrl = BaseUrlConstantsService.ADD_APPLICATION;
  private updateApplicationUrl = BaseUrlConstantsService.UPDATE_APPLICATION;
  public userListingUrl = BaseUrlConstantsService.END_USER_LIST;
  public siteUsersListingUrl = BaseUrlConstantsService.SITE_USERS_LIST;
  public energyMeterAPI = BaseUrlConstantsService.energyMeterApi;
  public sitesURL=BaseUrlConstantsService.BASE_SITE_URL

  public countries:any= [];
  public countryData:any = [];
  public states:any = [];
  public statesData:any = [];

  public makeBtnDisable: boolean;
  public options: FormGroup;
  public vpageRef: any;
  public showUpdateBtn: boolean;
  public showEditUsertxt: string;
  public showViewLicense: boolean;
  public showSavebtn: boolean;
  public visible = true;
  public selectable = true;
  public removable = true;
  public addOnBlur = true;
  public applicationdleted = false;
  public breadcrumbsArray: any = [{
    page_ref: 'site-groups',
    page_title: 'site'
  }, {
    page_ref: 'add-site-and-groups',
    page_title: 'add site'
  }];
  public uForm: FormGroup;
  public pageName: string;
  public pageType: string;
  public siteID: any;
  editDataObj: any;
  public siteName: string;
  _siteUsersList: any = [];
  _userList: any = [];
  userList: any = [];
  public groupName: string;
  public groupID: any;
  public showEnabledSaveBtn = true;
  public showDisabledSaveBtn: boolean;
  public showEnableUpdateBtn: boolean;
  public shouldShow: boolean;
  public showDisabledUpdateBtn: boolean;
  public company_name: string
  public today: Date;
  public compsitelist: any;
  constructor(
    public service: BackendApiService,
    private changeService: ChangeUsersService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public router: Router,
    private http: HttpClient,
    private activeRoute: ActivatedRoute) {
    this.company_name = localStorage.getItem('company_name');
    this.utcTime();
    activeRoute.queryParams.subscribe(params => {
      this.compsitelist = JSON.parse(params[`sites`]);
      this.pageType = params[`pageType`];

      if (this.pageType === 'edit-site') {
        this.editDataObj = JSON.parse(params[`siteObj`]);
        this.siteID = params[`siteID`];
        this.siteName = params[`siteName`];
        this.showUpdateBtn = true;
        this.showEditUsertxt = 'Edit Sites & Applications';
        this.showViewLicense = true;
        this.showSavebtn = false;
      } else {
        this.showUpdateBtn = false;
        this.showSavebtn = true;
        this.showEditUsertxt = 'Create Sites & Applications';
        this.showViewLicense = false;
      }
      this.pageName = params[`pageRef`];
      if (this.pageName === 'managerAssets') {
        const myObj = {
          page_ref: 'manager-client-list',
          page_title: 'manager clients'
        };
        this.breadcrumbsArray.unshift(myObj);
      }
    });
    this.options = formBuilder.group({
      hideRequired: false,
      floatLabel: 'auto',
    });
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  goBackToPage() {
    this.router.navigate(['/site-groups']);
  }

  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: 'managerAssets' === this.pageName ? 'managerAssets' : ''
      }
    };
    this.router.navigate([name], navigationExtras);
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  selectUserDropDown(index: number) {
    this.shouldShow = !this.shouldShow;
    if (this.shouldShow) {
      document.getElementById('user_' + index).classList.remove("hide");
      document.getElementById('user_' + index).classList.add("show");
    } else {
      document.getElementById('user_' + index).classList.remove("show");
      document.getElementById('user_' + index).classList.add("hide");
    }
  }

  showListOfUsers(i) {
    if (this.editDataObj.applications[i] === undefined) {
      return this.service.showError("Please save or update application first.");
    }
    let _groupId = this.editDataObj.applications[i].id
    let _siteId = this.editDataObj.id
    this._siteUsersList = [];
    this._userList = [];
    this.userList = [];
    let _associateUsers: any = 0;
    this.makeBtnDisable = true;
    this.service.getData(this.siteUsersListingUrl + "/" + _groupId + "/" + localStorage.getItem('user_id')).then(response => {
      this._siteUsersList = JSON.parse(JSON.stringify(response)).data.body;
      this.service.getData(this.userListingUrl + "/" + Math.floor(Math.random() * 90 + 10) + localStorage.getItem('user_id') + Math.floor(Math.random() * 9000 + 1000)).then(res => {
        this.makeBtnDisable = false;
        if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          this.userList = JSON.parse(JSON.stringify(res)).data.body;
          if (this.userList.length > 0) {
            for (let i = 0; i < this.userList.length; i++) {
              let user = this._siteUsersList.filter(data => data.id == this.userList[i].id);
              if (user != null && user.length > 0) {
                _associateUsers = this._siteUsersList.length;
                this._userList.push({ "id": user[0].id, "userid": this.userList[i].id, "full_name": this.userList[i].full_name, "email": this.userList[i].email, "checked": true });
              } else {
                this._userList.push({ "id": null, "userid": this.userList[i].id, "full_name": this.userList[i].full_name, "email": this.userList[i].email, "checked": false });
              }
            }
          }
          const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
            width: '650px',
            data: {
              type: 'ClientGroupAssociateUsers',
              userList: this._userList,
              siteid: _siteId,
              group_id: _groupId,
              _associateUsers: _associateUsers
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result !== undefined) {
              // .log(`Dialog result: ${result}`);
            }
          });
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    });
  }


  ngOnInit() {
    this.getCountries();

    this.formBuilder.array([]);
    if (this.pageType === 'edit-site') {
      this.onCountryChange(this.editDataObj.country_fk);
      this.uForm = this.formBuilder.group({
        site_name: new FormControl({ value: this.editDataObj.name, disabled: false }, [Validators.required, this.noWhitespaceValidator]),
        site_description: new FormControl(this.editDataObj.site_description),
        site_address1: new FormControl(this.editDataObj.address_1),
        site_city: new FormControl(this.editDataObj.city),
        site_state: new FormControl(this.editDataObj.state_fk),
        site_country: new FormControl(this.editDataObj.country_fk),
        //group_name: this.formBuilder.array([], [Validators.required]),
        application_groups: this.formBuilder.array([], Validators.required),
        group_description: new FormControl(this.editDataObj.applications.length === 0 ? "" : this.editDataObj.applications[0].description)
      });


      if (this.editDataObj.applications.length !== 0) {
        for (let app of this.editDataObj.applications) {
          this.application_groups().push(this.editgroup_name(app.name, app.id));

        }
      } else {
        this.application_groups().push(this.newApplicationGroup());
      }
    } else {
      this.uForm = this.formBuilder.group({
        site_name: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
        site_description: new FormControl(''),
        site_address1: new FormControl('', [Validators.required]),
        site_city: new FormControl('', [Validators.required]),
        site_state: new FormControl('', [Validators.required]),
        site_country: new FormControl('', [Validators.required]),
        //group_name: this.formBuilder.array([], Validators.required),
        application_groups: this.formBuilder.array([], Validators.required),
        group_description: new FormControl('')
      });
      this.application_groups().push(this.newApplicationGroup());
    }

  }

  getCountries(){
    this.service.getDataWithQuery(this.sitesURL+"country-list/").then((sRes) => {

      let countryRes= JSON.parse(JSON.stringify(sRes)).data;

        if (countryRes.body && Object.keys(countryRes.body).length !== 0) {

          let response = countryRes.body;

          this.countries =[];

          if (response != undefined){

            if(response.length != 0){

              this.countryData= response;

              if (this.countryData.length !== 0) {

                for (let mCount = 0; mCount < this.countryData.length; mCount++) {

                  let id="";
                  let name = "";
                  let country_code = "";
                  let currency = "";

                  id = this.countryData[mCount].id;
                  name = this.countryData[mCount].name;
                  country_code = this.countryData[mCount].country_code;
                  currency = this.countryData[mCount].currency;

                  const countryListingsData = {
                    // value:value,
                    id: id,
                    name:  name,
                    country_code:  country_code,
                    currency:  currency
                  };

                  this.countries.push(countryListingsData);

                }


              }

            }

          }

        }
    });
  }


  onCountryChange(countryID){
    this.service.getDataWithQuery(this.sitesURL+"all-state-by-id/"+countryID).then((sRes) => {

      let stateRes= JSON.parse(JSON.stringify(sRes)).data;

        if (stateRes.body && Object.keys(stateRes.body).length !== 0) {

          let response = stateRes.body;

          this.states =[];

          if (response != undefined){

            if(response.length != 0){

              this.statesData= response;

              if (this.statesData.length !== 0) {

                for (let mCount = 0; mCount < this.statesData.length; mCount++) {

                  let id="";
                  let name = "";

                  id = this.statesData[mCount].id;
                  name = this.statesData[mCount].name;

                  const stateListingsData = {
                    id: id,
                    name:  name
                  };

                  this.states.push(stateListingsData);

                }


              }

            }

          }

        }

    });
  }

  application_groups(): FormArray {
    return this.uForm.get("application_groups") as FormArray;
  }
  editgroup_name(goName, id): FormGroup {

    return this.formBuilder.group({
      group_name: new FormControl(goName, [Validators.required]),
      application_id: new FormControl(id)

    });
  }

  newApplicationGroup(): FormGroup {
    return this.formBuilder.group({
      group_name: new FormControl('', Validators.required)

    });
  }

  addQuantity() {
    this.application_groups().push(this.newApplicationGroup());
  }

  removeQuantity(i: number, application_group: any) {
    console.log('remove quantity: ', i, application_group)
    this.application_groups().removeAt(i);
    this.deleteApplication(application_group.controls.application_id.value)
  }

  deleteApplication(id) {
    console.log('delete id: ', id)
    this.service.deleteInfo(this.applicationDeleteUrl + "/" + id).then(res => {
      if (JSON.parse(JSON.stringify(res)).data.message.includes("successfully deleted")) {
        this.service.showSuccess('Successfully deleted.');
      } else {
        this.service.showSuccess('Something went wrong.');
      }
    });
  }


  saveSite() {

    console.log(this.uForm,'this.uForm..........saveSite()')
    let countdup = 0;
    //code to check site duplicacy
    for (let j = 0; j < this.compsitelist.length; j++) {

      if (this.compsitelist[j].name == this.uForm.value.site_name) {
        countdup += 1;
      }

    }
    if (countdup >= 1) {
      this.service.showError(' Site Already Exist');
    }
    else {
      if (this.uForm.dirty && this.uForm.valid) {

        const body = {
          user_id: localStorage.getItem('user_id'),
          name: this.uForm.value.site_name,
          site_description: this.uForm.value.site_description,
          address_1: this.uForm.value.site_address1,
          city: this.uForm.value.site_city,
          state_fk: this.uForm.value.site_state,
          country_fk: this.uForm.value.site_country
        };
        console.log(body,'bodybody..')
        this.showEnabledSaveBtn = false;
        this.showDisabledSaveBtn = true;
        this.changeService.loader(true);
        this.service.postData(this.siteAddUrl, body).then(async (res) => {

          this.changeService.loader(false);
          this.showEnabledSaveBtn = true;
          this.showDisabledSaveBtn = false;
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {

            const msgErr = JSON.parse(JSON.stringify(res)).data.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {

            // for (let d = 0; d < this.uForm.value.group_name.length; d++) {
            let d = 0;
            if (this.uForm.value.application_groups.length > 1) {
              if (d == 0) {
                let applicationObj = {
                  siteID: JSON.parse(JSON.stringify(res)).data.siteInsertID,
                  applicationName: this.uForm.value.application_groups[d].group_name,
                  applicationDescription: this.uForm.value.group_description,
                }
                this.saveApplicationGroup(applicationObj, this.uForm.value.application_groups.length - 1, d);
              }
              for (let k = d + 1; k < this.uForm.value.application_groups.length; k++) {
                d++;
                if (JSON.stringify(this.uForm.value.application_groups[0].group_name) == JSON.stringify(this.uForm.value.application_groups[k].group_name)) {
                  this.service.showError('Applications Cannot be same');
                }
                else {
                  let applicationObj = {
                    siteID: JSON.parse(JSON.stringify(res)).data.siteInsertID,
                    applicationName: this.uForm.value.application_groups[d].group_name,
                    applicationDescription: this.uForm.value.group_description,
                  }
                  this.saveApplicationGroup(applicationObj, this.uForm.value.application_groups.length - 1, d);
                }
              }
            }
            else {
              let applicationObj = {
                siteID: JSON.parse(JSON.stringify(res)).data.siteInsertID,
                applicationName: this.uForm.value.application_groups[d].group_name,
                applicationDescription: this.uForm.value.group_description,
              }
              this.saveApplicationGroup(applicationObj, this.uForm.value.application_groups.length - 1, d);

              // }


            }


          } else {
            this.service.showError('Something went wrong.');
          }
        });
      }
    }




  }


  saveApplicationGroup(appObj, totalLength, index) {
    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        user_id: localStorage.getItem('user_id'),
        site_id: appObj.siteID,
        name: appObj.applicationName,
        description: appObj.applicationDescription
      };
      this.changeService.loader(true);
      this.service.postData(this.addApplicationUrl, body).then(async (res) => {

        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.message;

          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {

          if (totalLength === index) {
            this.service.showSuccess('Site registered successfully');
            this.router.navigate(['/site-groups']);
          }
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }


  addDevice() {
    this.router.navigate(['/add-site-and-groups']);
  }
  saveDevice() {
    console.log(this.uForm,'this.uForm..........SaveDevice()',this.applicationdleted)


    if ((this.uForm.dirty && this.uForm.valid) || this.applicationdleted) {
      // If editing sites & applications, remove the site from the list
      if (this.showEditUsertxt === 'Edit Sites & Applications') {
        const index = this.compsitelist.findIndex(e => e.name === this.editDataObj.name);
        if (index >= 0) {
          this.compsitelist.splice(index, 1);
        }
      }

      //  updating or adding the site
      const body = {
        user_id: localStorage.getItem('user_id'),
        name: this.uForm.value.site_name,
        site_description: this.uForm.value.site_description,
        address_1: this.uForm.value.site_address1,
        city: this.uForm.value.site_city,
        state_fk: this.uForm.value.site_state,
        country_fk: this.uForm.value.site_country
      };

      // Call API to update or add the site
      this.service.putData(`${this.updateSiteUrl}/${this.editDataObj.id}`, body).then(res => {
        this.changeService.loader(false);
        this.showEnabledSaveBtn = true;
        this.showDisabledSaveBtn = false;
        const responseData = JSON.parse(JSON.stringify(res)).data;

        if (responseData.status === 'fail') {
          const msgErr = responseData.message;
          this.service.showError(msgErr);
        } else if (responseData.status === 'success') {
          // Update applications if any

          if (this.uForm.value.application_groups && this.uForm.value.application_groups.length > 0) {
            this.uForm.value.application_groups.forEach((group, index) => {

              const applicationObj = {
                siteID: responseData.siteInsertID,
                applicationName: group.group_name,
                applicationDescription: this.uForm.value.group_description,
              };

              this.updateApplicationGroup(applicationObj, index, this.uForm.value.application_groups.length - 1, group.application_id);
            });
          }
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    } else {
      this.service.showError('Please make some changes before update..........');
    }
  }

  updateApplicationGroup(appObj, totalLength, index, applicatonID) {

    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        user_id: localStorage.getItem('user_id'),
        site_id: this.editDataObj.id,
        name: appObj.applicationName,
        description: appObj.applicationDescription
      };

      this.changeService.loader(true);
      if (applicatonID !== undefined) {
        this.service.putData(this.updateApplicationUrl + "/" + applicatonID, body).then(res => {

          this.changeService.loader(false);
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(res)).data.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            if (totalLength === index) {
              this.service.showSuccess('Site updated successfully');
              this.router.navigate(['/site-groups']);
            }
          } else {
            this.service.showError('Something went wrong.');
          }
        });
      } else {
        this.service.postData(this.addApplicationUrl, body).then(async (res) => {
          this.changeService.loader(false);
          if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
            const msgErr = JSON.parse(JSON.stringify(res)).data.message;
            this.service.showError(msgErr);
          } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
            if (totalLength === index) {
              this.service.showSuccess('Site registered successfully');
              this.router.navigate(['/site-groups']);
            }
          } else {
            this.service.showError('Something went wrong.');
          }
        });
      }



    }

  }

  saveAndAddGroup() {
    if (this.uForm.dirty && this.uForm.valid) {
      const body = {
        client_id: localStorage.getItem('user_id'),
        name: this.uForm.value.site_name,
        address_1: this.uForm.value.site_address1,
        city: this.uForm.value.site_city,
        state_fk: this.uForm.value.site_state,
        country_fk: this.uForm.value.site_country
      };
      this.changeService.loader(true);
      this.service.postData(this.siteAddUrl, body).then(res => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === 'fail') {
          const msgErr = JSON.parse(JSON.stringify(res)).data.body.message;
          this.service.showError(msgErr);
        } else if (JSON.parse(JSON.stringify(res)).data.status === 'success') {
          const id = JSON.parse(JSON.stringify(res)).data.body.id;
          const name = JSON.parse(JSON.stringify(res)).data.body.name;
          const address_1 = JSON.parse(JSON.stringify(res)).data.body.address_1;
          const city = JSON.parse(JSON.stringify(res)).data.body.city;
          const state_fk = JSON.parse(JSON.stringify(res)).data.body.state_fk;
          const country_fk = JSON.parse(JSON.stringify(res)).data.body.country_fk;

          this.service.showSuccess('Site registered successfully');
          const navigationExtras = {
            skipLocationChange: true,
            queryParams: {
              siteID: id,
              siteName: name,
              siteAddress:address_1,
              siteCity:city,
              siteState:state_fk,
              siteCountry:country_fk
            }
          };
          this.router.navigate(['add-group'], navigationExtras);
        } else {
          this.service.showError('Something went wrong.');
        }
      });
    }
  }
}
